import React from 'react';
import PropTypes from 'prop-types';
import { UserProfile } from 'features/users/ui/UserProfile';
import { Username } from 'features/users/ui/UserName';
import { IconWhiteClose } from 'assets/images';
import styles from './selectedUserChips.module.scss';

const SelectedUserChips = ({ selectedUsers, onRemove }) => {
   if (!selectedUsers || selectedUsers.length === 0) return null;

   return (
      <div className={`${styles.chipsContainer} ct-flex ct-fwrap ct-gap8 ct-scroll`}>
         {selectedUsers.map(userId => (
            <div key={userId} className={`${styles.chip} ct-flex ct-aiCenter ct-gap8`}>
               <div className={`${styles.chipAvatar} ct-flexCenter`}>
                  <UserProfile userId={userId} className="chat-avatar ct-flexCenter " />
               </div>
               <span className={`${styles.chipName} ct-ellipsis`}>
                  <Username userId={userId} />
               </span>
               <button className={`${styles.removeBtn} ct-flexCenter ct-cursor`} onClick={() => onRemove?.(userId)}>
                  <IconWhiteClose />
               </button>
            </div>
         ))}
      </div>
   );
};

SelectedUserChips.propTypes = {
   selectedUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
   onRemove: PropTypes.func.isRequired,
};

export default SelectedUserChips;
